import { TTypeOfCreateStudioModalWindow } from './createStudioModalState/createStudioModalContext';
import { ICreateVideoStudio } from 'types';

export enum CreateStudioActionTypes {
	CHANGE_NAME = 'CHANGE_NAME',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IChangeName {
	type: CreateStudioActionTypes.CHANGE_NAME;
	payload: {
		name: string;
	};
}

interface ISetDataForSubmit {
	type: CreateStudioActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: ICreateVideoStudio | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: CreateStudioActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfCreateStudioModalWindow;
	};
}

interface IResetSelectedControls {
	type: CreateStudioActionTypes.RESET_FIELDS;
}

export type TCreateStudioAction = IChangeName | ISetDataForSubmit | IChangeTypeOfModalWindow | IResetSelectedControls;
